import React from 'react';
import './Contact.css';
import {FaTelegramPlane} from "react-icons/fa";
import { FaSkype } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { AiFillInstagram } from "react-icons/ai";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";

import { FaLocationArrow } from "react-icons/fa6";
import { MdOutlineMailOutline } from "react-icons/md";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";

import facebookIcon from '../../../assets/images/icons/facebookIcon.svg'
import skypeIcon from '../../../assets/images/icons/skypeIcon.svg'
import telegramIcon from '../../../assets/images/icons/telegramIcon.svg'
import whatsAppIcon from '../../../assets/images/icons/whatsUpIcon.svg'
import instIcon from '../../../assets/images/icons/instIcon.svg'

import phoneIcon from '../../../assets/images/icons/phoneIcon.svg'
import mailIcon from '../../../assets/images/icons/mailIcon.svg'
import adressIcon from '../../../assets/images/icons/adressIcon.svg'

import whyContactIcon1 from '../../../assets/images/icons/whyContactIcon1.svg'
import whyContactIcon2 from '../../../assets/images/icons/whyContactIcon2.svg'
import whyContactIcon3 from '../../../assets/images/icons/whyContactIcon3.svg'
import whyContactIcon4 from '../../../assets/images/icons/whyContactIcon4.svg'
import ContactFormWithBackground from '../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';
import Footer from '../../../components/Footer/Footer';






const Contact = () => {

    const breadcrumbs = [
        { name: 'Offshore Advisory', link: '/' },
        {
            name: 'Contact us',
            link: '/contact',
        },
    ]

    const crumbs = breadcrumbs && breadcrumbs.length > 0 ? breadcrumbs : '';

    const whyContactsArray = [
        {
            id: 1,
            point: "(01)",
            title: 'Global Presence',
            img: whyContactIcon1,
            descr: 'Offices in UK, Cyprus, and Albania.'
        },
        {
            id: 2,
            point: "(02)",
            title: 'Expertise',
            img: whyContactIcon2,
            descr: 'Specialized in licensing, offshore structures, and compliance.'
        },
        {
            id: 3,
            point: "(03)",
            title: 'Proven Track Record',
            img: whyContactIcon3,
            descr: 'Offices in UK, Cyprus, and Albania.'
        },
        {
            id: 4,
            point: "(04)",
            title: 'Fast & Personalized Service',
            img: whyContactIcon4,
            descr: 'Offices in UK, Cyprus, and Albania.'
        },
    ]

    

    return (
        <main className='main'>
            <div className='contact-us-background'>
            
                <div className='contact-us-container'>
                    <div className='contact-us-left'>
                        <h2 className='contact-us-title'>
                            Contact us
                        </h2>
                        <div className='contact-us-social-row'>
                            <span className='contact-us-social-text'>
                                We are in social networks:
                            </span>
                            <a>
                                <img src={facebookIcon}/>
                            </a>
                            <a>
                                <img src={skypeIcon} />
                            </a>
                            <a>
                                <img src={telegramIcon} />
                            </a>
                            <a>
                                <img src={whatsAppIcon} />
                            </a>
                            <a>
                                <img src={instIcon} />
                            </a>
                        </div>
                    </div>
                    <div className='contact-us-right'>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                Phone
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={phoneIcon} />
                                    <a href='tel:+4407385054407' >
                                        +4407385054407
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                Email
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={mailIcon} />
                                    
                                    
                                    <div>
                                        <a href='mailto:info@offshoreadvisory.pro'>info@offshoreadvisory.pro</a>
                                        <a href='tel:compliance@offshoreadvisory.pro'>compliance@offshoreadvisory.pro</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                Address
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={adressIcon}  />
                                    25B RICHMOND TERRACE, LIVERPOOL, UNITED KINGDOM, L6 5HU
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='why-contact-container'>
                <div className='why-contact-left'>
                    <h2 className='why-contact-title'>
                        Why Contact Offshore Advisory?
                    </h2>
                </div>
                <div className='why-contact-right'>
                    {whyContactsArray.map((item) => (
                        <div className='why-contact-item' key={item.id}>
                            <div className='why-contact-header-content'>
                                    <span className='why-contact-point'>
                                        {item.point}
                                    </span>
                                    <h2>
                                        {item.title}
                                    </h2>
                            </div>
                            <div className='why-contact-img-wrapper'>
                                        <img src={item.img} />
                                    </div>
                                    <p className='why-contact-descr'>
                                        {item.descr}
                                    </p>
                        </div>
                    ))}
                    
                </div>
            </div>
            <ContactFormWithBackground />
            {/* <Footer /> */}
        </main>
    );
}

export default Contact;

const FAQListData = [
    {
        question: "How fast do you respond to inquiries?",
        answer: "Within 24 hours on weekdays."
    },
    {
        question: "Can we schedule a video consultation?",
        answer: "Yes — we arrange meetings via Zoom, Teams, or WhatsApp."
    },
    {
        question: "Do you work with startups as well as established firms?",
        answer: "Yes — from entrepreneurs to multinational groups, we customize solutions for every client."
    }
];

const testimonialsData = [
    {
        quote: "I reached out through the Offshore Advisory contact form and had a full consultation the next day. They explained everything about gaming and crypto licensing clearly.",
        author: "John P.",
        role: "FinTech Entrepreneur"
    }
];
